

import BehaviorExpression from './expression/behavior_expression';
import BehaviorActionFactory from './action/behavior_action_factory';
import BehaviorEvent from './event/behavior_event';

export default class Behavior {
	_events;
	_condition;
	_actions;

	constructor(props = {}) {
		Object.keys(props)
			.forEach((propName) => this[propName] = props[propName]);

		this._events = this._buildBehaviorEvents(props.events);
		this._condition = this._buildBehaviorCondition(props.condition);
		this._actions = this._buildBehaviorActions(props.actions);
	}

	_buildBehaviorEvents(events) {
		return events ? events.map((event) => new BehaviorEvent(event)) : [];
	}

	_buildBehaviorCondition(condition) {
		return condition ? new BehaviorExpression(condition) : {};
	}

	_buildBehaviorActions(actions) {
		return actions ? actions.map((action) => BehaviorActionFactory.create(action)) : [];
	}

	get events() {
		return this._events;
	}

	set events(events) {
		this._events = this._buildBehaviorEvents(events);
	}

	get condition() {
		return this._condition;
	}

	set condition(condition) {
		this._condition = this._buildBehaviorCondition(condition);
	}

	get actions() {
		return this._actions;
	}

	set actions(actions) {
		this._actions = this._buildBehaviorActions(actions);
	}
}
